module.exports = __webpack_public_path__ + "img/law_l_r_sidebar.51f9daf1.jpg";